<template>
    <div class="">
      <!-- <app-breadcrumb :page-title="$t('calendar_view')" /> -->
      <div v-if="this.active != 1" class="mb-2">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item v-if="this.active < 3">
            <a href="" @click.prevent="previous">Calendar</a>
          </el-breadcrumb-item>
          <el-breadcrumb-item>Task Detail</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- <button
              type="button"
              class="btn btn-sm btn-primary el-button--default"
              v-if="this.active < 3"
              @click="previous"
              style="float: right"
            >
              <span>Previous</span>
            </button> -->
      </div>
      <el-form v-if="active === 1">
        <div v-click-outside="closeAddEditModal">
          <div class="card card-with-shadow min-height-400 border-0">
            <div class="card-body p-primary">
              <app-calendar :preloader="preloader" :options="options" />
            </div>
          </div>
  
          <!--Add popup modal-->
          <event-add-edit-modal
            :event-data="eventData"
            :selected-url="selectedUrl"
            @reloadCalendar="initCalendar"
          />
        </div>
      </el-form>
      <el-form v-if="active === 2">
        <task-mytask-view :id="id" :active="{ active }" :remove="classRemove"></task-mytask-view>
      </el-form>
    </div>
  </template>
  
  <script>
  import CoreLibrary from "../../../../../core/helpers/CoreLibrary";
  import { CALENDARS, CALENDER_TASK } from "../../../../Config/ApiUrl";
  
  export default {
    name: "CalendarView",
    extends: CoreLibrary,
    data() {
      return {
        active: 1,
        id: 0,
        classRemove: true,
        selectedUrl: "",
        eventData: "",
        preloader: false,
        dotColorClass: ["black", "green", "brown", "blue", "yellow", "red"],
        backGroundColorClass: [
          "yellow",
          "red",
          "blue",
          "black",
          "brown",
          "green",
        ],
        options: {
          select: this.createEvent,
          eventClick: this.selectedEvent,
          initialEvents: [],
        },
      };
    },
    created() {
      this.initCalendar();
    },
    methods: {
      previous() {
          this.active = 1;
      },
      initCalendar() {
        this.preloader = true;
        let x = localStorage.getItem("calendar-default-view");
        if (x) this.options.initialView = x;
        else this.options.initialView = "timeGridWeek";
        this.axiosGet(CALENDER_TASK+'?job_id='+this.$attrs['props'].jobId)
          .then((res) => {
            for (let i = 0; i < res.data.length; i++) {
              const className =
                res.data[i].title.replace(/[^a-zA-Z]/g, "") +
                "-" +
                res.data[i].id;
              res.data[i].className = className;
              res.data[i].color = this.dotColorClass[i];
              let style = document.createElement("style");
              style.innerHTML = `.fc-event.${className} { background-color: ${this.backGroundColorClass[i]} !important; color: black !important; }`;
              document.getElementsByTagName("head")[0].appendChild(style);
            }
            this.options.initialEvents = res.data;
          })
          .finally(() => {
            this.preloader = false;
            this.setView();
          });
      },
      closeAddEditModal() {
        document
          .getElementsByClassName("custom-modal")[0]
          .classList.add("d-none");
        this.selectedUrl = "";
      },
      createEvent(arg) {
        this.eventData = arg;
        this.selectedUrl = "";
      },
      selectedEvent(arg) {
  
          this.id = arg.event.id;
          this.active = 2;
  
        // this.selectedUrl = `${CALENDARS}/${arg.event.id}`;
        // this.eventData = arg;
      },
      setView() {
        setTimeout(() => {
          $(".fc-dayGridMonth-button").click(() => {
            localStorage.setItem("calendar-default-view", "dayGridMonth");
          });
          $(".fc-timeGridWeek-button").click(() => {
            localStorage.setItem("calendar-default-view", "timeGridWeek");
          });
          $(".fc-timeGridDay-button").click(() => {
            localStorage.setItem("calendar-default-view", "timeGridDay");
          });
        }, 1000);
        this.$refs.calendar.$emit("refetch-events");
      },
    },
  };
  </script>
  